export default function useStore({
  open,
}: {
  open: (message: string) => void;
}): [(appUrl?: string, storeUrl?: string) => void] {
  const storeCall = function (appUrl?: string, storeUrl?: string) {
    var varUA = navigator.userAgent.toLowerCase(); //userAgent 값 얻기

    if (varUA.indexOf("android") > -1) {
      if (window.SANDI && window.SANDI.store) {
        window.SANDI.store(appUrl, storeUrl);
      } else {
        open("앱 연동 호출에 실패하였습니다.");
      }
    } else if (
      varUA.indexOf("iphone") > -1 ||
      varUA.indexOf("ipad") > -1 ||
      varUA.indexOf("ipod") > -1
    ) {
      window.webkit?.messageHandlers.store.postMessage(
        JSON.stringify({ appUrl, storeUrl })
      );
    } else {
      open("모바일 기기에서 시도해주세요.");
    }
  };

  return [storeCall];
}
